import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import icon1 from "../../components/common/Images/icon1.svg";
import image6 from "../../components/common/Images/image6.jpg";

const HomePage = (props: any) => {
	const navigate = useNavigate();

	const gotToPage = (path: string) => {
		navigate(path);
	};

	return (
		<>
			<div
				style={{
					display: "flex",
					width: "100%",
					padding: "20px",
					flexDirection: "column",
					alignItems: "flex-start",
					background: `radial-gradient(158.42% 209.16% at 6.42% 142.67%, #86BC25 0%, #03502A 46.6%, rgba(0, 0, 0, 0.00) 100%), url(${image6}) lightgray 50% `,
				}}
			>
				<p className="text-white text-fs32 font-bold">
					Welcome ,{" "}
					<span className="text-fs32 font-bold text-mainGreen">
						{localStorage.getItem("user_name")?.replace(/,/g, " ")}
					</span>
				</p>
				<p className="text-fs28 text-white">CatMan Toolkit </p>
				<p className="text-white text-1.1em">
					An "always-on" customized “Category Excellence”
					recommendation engine, designed to identify strategic
					opportunities and actions for margin expansion .
				</p>
			</div>
			<div className="second-section ">
				<div className="textLarge text-black font-bold">
					Your CategoryIQ Tools
				</div>
				<div className="col-span-6 w-full border-gray-500 flex justify-center items-center">
					<div className="grid-container">

						<div className="cards">
							<div className="cards-content">
								<div className="w-full px-3">
									<p className="text-[#000] textNormal text-left font-bold">
										Baseline and Performance
									</p>
									<p className="text-[#000] italic textNormal text-left pt-1.5 pb-[3.3vh]">
										Summary of baseline views and
										performance by categories, districts,
										and suppliers .
									</p>
									<div className="button-container">
										<button
											onClick={() => gotToPage("/alerts")}
											className="tab-btn"
										>
											Category Alert
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button>
										<button
											onClick={() => gotToPage("/category-performance")} 
											className="tab-btn">
											Category Performance
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button>
										<button
											onClick={() =>
												gotToPage("/baseline")
											}
											className="tab-btn"
										>
											Category Baseline
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button>
										{/* <button
											onClick={() =>
												gotToPage("/industry-insights")
											}
											className="tab-btn"
										>
											Industry Insights
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button> */}
									</div>
								</div>
							</div>
						</div>

						<div className="cards">
							<div className="cards-content">
								<div className="w-full px-2">
									<p className="text-[#000] textNormal text-left font-bold">
										Category Strategy Recommendations
									</p>
									<p className="text-[#000] textNormal italic text-left py-1.5">
										Summary view of growth vs profitability
										& strategic recommendations by
										categories, districts and suppliers.
									</p>
									<div className="button-container">
										
										<button
											onClick={() =>
												gotToPage("/profitability")
											}
											className="tab-btn"
										>
											Category Profitability
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button>
									</div>
								</div>
							</div>
						</div>

						<div className="cards">
							<div className="cards-content">
								<div className="w-full px-2">
									<p className="text-[#000] textNormal text-left font-bold">
										Sourcing & Strategic Supplier
										Negotiations
									</p>
									<p className="text-[#000] italic textNormal text-left py-1.5">
										Detailed recommendations to create an
										effective product assortment strategy
										and increase overall margin .
									</p>
									<div className="button-container">
										<button
											onClick={() =>
												gotToPage("/opportunities")
											}
											className="tab-btn"
										>
											NIA Peer Benchmark
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button>

										<button
											onClick={() =>
												gotToPage("/nia-simulator")
											}
											className="tab-btn"
										>
											Forward Buy Recommendations
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button>

										<button
											onClick={() =>
												gotToPage("/cost-optimization")
											}
											className="tab-btn"
										>
											Cost Optimization
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button>
										
										<button
											onClick={() =>
												gotToPage(
													"/supplier-consolidation"
												)
											}
											className="tab-btn"
										>
											Supplier Consolidation
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button>
										{/* <button
											onClick={() =>
												gotToPage(
													"/parametric-analysis"
												)
											}
											className="tab-btn"
										>
											Parametric Analysis
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button> */}
									</div>
								</div>
							</div>
						</div>

						<div className="cards">
							<div className="cards-content">
								<div className="w-full px-2">
									<p className="text-[#000] textNormal text-left font-bold">
										Assortment & Product
									</p>
									<p className="text-[#000] italic textNormal text-left pt-1.5 pb-[3.3vh]">
										Identifies price optimization
										opportunities basis the Floor Price and
										Target Price range.
									</p>
									<div className="button-container">
										<button
											onClick={() =>
												gotToPage("/sku-management")
											}
											className="tab-btn"
										>
											SKU Management
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button>
										<button
											onClick={() =>
												gotToPage("/portfolio")
											}
											className="tab-btn"
										>
											Portfolio Gap
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button>
									</div>
								</div>
							</div>
						</div>

						<div className="cards">
							<div className="cards-content">
								<div className="w-full px-2">
									<p className="text-[#000] textNormal text-left font-bold">
										Commercial & Pricing
									</p>
									<p className="text-[#000] italic textNormal text-left py-1.5">
										In-depth analysis and scenario
										simulations to support supplier
										negotiations for maximizing margins .
									</p>
									<div className="button-container">
										<button
											onClick={() =>
												gotToPage("/pricing")
											}
											className="tab-btn"
										>
											Commercial Optimization
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button>
										
									</div>
								</div>
							</div>
						</div>

						<div className="cards">
							<div className="cards-content">
								<div className="w-full px-2">
									<p className="text-[#000] textNormal text-left font-bold">
										Value Tracking
									</p>
									<p className="text-[#000] italic textNormal text-left py-1.5">
										Tracks value captured through category
										strategy implementation, and NIA
										negotiations .
									</p>
									<div className="button-container">
										<button
											onClick={() =>
												gotToPage("/value-capture")
											}
											className="tab-btn"
										>
											Category Strategy Implementation
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button>
										<button
											onClick={() => {
												gotToPage("/nia-negotiations");
											}}
											className="tab-btn"
										>
											NIA Negotiations
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button>
										<button
											onClick={() => {
												gotToPage("/margin-preservation");
											}}
											className="tab-btn"
										>
											Margin Preservation Dashboard
											<img
												src={icon1}
												className="h-3 w-3"
											/>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default HomePage;
